<div class="header-container">
  <img src="./assets/images/header_footer.png" class="header-bg-img" />

  <div class="header-logo-container">
    <table>
      <tr class="header-row">
        <td *ngIf="isHomeLinkEnabled">
          <a class="home-btn" href="/" matTooltip="Home">
            <i class="fa fa-home" aria-hidden="true"></i>
          </a>
        </td>
        <td *ngIf="user_roles?.length > 1 && isActiveIcon == 'true' && isActiveUrl">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu"
            class="menu-btn">
            <i class="fa fa-list" aria-hidden="true"></i>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item *ngFor="let role of user_roles" (click)="selectTool(role.role_privilege_route)">
              <img src="{{ role.image_path }}" class="asterisk-tool-logo" />
              <span class="menu-text">{{ role.label }}</span>
            </button>
          </mat-menu>
        </td>
        <td>
          <span class="logo-container" (click)="navigateToHome()" matTooltip="Module Home">
            <img src="./assets/images/ey_logo.svg" class="asterisk-logo" />
          </span>
        </td>
        <td *ngIf="globalService?.toolName" tabindex="0" (click)="navigateToHome()" matTooltip="Module Home">
          <div class="header-text">{{ globalService.toolName }}</div>
        </td>
      </tr>
    </table>
  </div>
  <div class="header-user-container">
    <div class="header-user-table">
      <table *ngIf="userFullName">
        <tr>
          <td *ngIf="isSupportLinkEnabled">
            <img alt="Customer Support" src="./assets/images/customer-support.png" class="support-logo mr-2"
              matTooltip="Customer Support" (click)="openSupportLink()" />
          </td>
          <td><img alt="User Picture" src="./assets/images/user_login.png" class="user-picture" /></td>
          <td>
            <div class="user-info">{{ userFullName }}</div>
            <div *ngIf="userRole" class="user-info">{{ userRole }}</div>
          </td>
          <td tabindex="0" style="position: relative;">
            <ul class="nav navbar-nav navbar-right nav-mt">
              <li class="dropdown" style="position: relative;">
                <a href="#" class="dropdown-toggle d-toggle"
                  (click)="toggleDropdown($event)"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <span class="caret"></span>
                </a>

                <div class="dropdown-menu dropdown-menu-right d-menu"
                    [class.show]="dropdownOpen">
                  <a class="dropdown-item d-menu-item" tabindex="0" (click)="toggleFullscreen()">Fullscreen</a>
                  <a class="dropdown-item d-menu-item" tabindex="0" (click)="logout()" *ngIf="!ssoEnabled">Logout</a>
                </div>
              </li>
            </ul>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>